import { createSlice } from "@reduxjs/toolkit";
import { authService } from "../service/auth";
import { LOCAL_STORAGE } from "utils/constant";
import toast from "react-hot-toast";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: localStorage.getItem(LOCAL_STORAGE.USER_INFO) || null,
    isLoggedIn: localStorage.getItem(LOCAL_STORAGE.USER_TOKEN) ? true : false,
    token: localStorage.getItem(LOCAL_STORAGE.USER_TOKEN) | null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.isLoggedIn = false;
      state.token = null;
      localStorage.removeItem(LOCAL_STORAGE.USER_TOKEN);
      localStorage.removeItem(LOCAL_STORAGE.USER_INFO);
      toast.success("Logged out");
      setTimeout(() => {
        window.location.href = "/";
      }, 1000);
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(authService.endpoints.loginWithGoogle.matchFulfilled, (state, action) => {
      if (action.payload.statusCode == 200 && action.payload.response.statusEnum == 1) {
        state.user = action.payload.response.data.user;
        state.isLoggedIn = true;
        state.token = action.payload.response.data.accessToken;
        localStorage.setItem(LOCAL_STORAGE.USER_TOKEN, state.token);
        localStorage.setItem(LOCAL_STORAGE.USER_INFO, JSON.stringify(state.user));
      }
    });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
